/* eslint-disable max-len */
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import * as qs from 'query-string';
import { Button } from 'primereact/button';
import gql from 'graphql-tag';
import { useLocation } from 'react-router-dom';
import apollo from '../services/apollo';
import { NotificationContext } from '../components/GrowlNotifications';

const SEND_VERIFICATION_EMAIL = gql`
  mutation($userId: ID!) {
    sendEmailVerification(userId: $userId)
  }
`;

const sendVerificationEmail = userId => apollo
  .mutate({
    mutation: SEND_VERIFICATION_EMAIL,
    variables: {
      userId,
    },
  })
  .then(res => res.data);


const RegisterConfirmation = () => {
  const growl = useContext(NotificationContext);
  const { search } = useLocation();

  const sendEmailVerification = async () => {
    const { userId } = qs.parse(search);

    try {
      await sendVerificationEmail(userId);
    } catch (error) {
      growl.show({ severity: 'error', detail: error.message, sticky: true });
    }
  };

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <div className="p-grid">
            <div className="p-col-6 p-offset-3">
              <FormattedMessage
                id="register-confirmation.header"
                defaultMessage="You have finished the registration process and you are now present as a user in our system"
                tagName="h3"
              />
              <FormattedMessage
                id="register-confirmation.paragraph1"
                defaultMessage="We've also sent you an email to verify the email address you entered during registration."
                tagName="p"
              />
              <FormattedMessage
                id="register-confirmation.paragraph2"
                defaultMessage="If you think you've not received the email check your junk / spam folder or wait a few minutes."
                tagName="p"
              />
              <FormattedMessage
                id="register-confirmation.paragraph3"
                defaultMessage="If you still haven't received the email by then, please click the button below to have a new email sent to you."
                tagName="p"
              />
              <FormattedMessage id="register-confirmation.button" defaultMessage="Send verification email">
                {text => (
                  <Button
                    type="button"
                    label={text}
                    onClick={sendEmailVerification}
                  />
                )}
              </FormattedMessage>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default RegisterConfirmation;
